import React from 'react';
import { Document } from '../../../../graphql/graphql';
import styles from './CSSZSickLeaveCertificateDetailSubmissionItem.module.scss';
import { getMomentDate } from '../../../../Utils/dates.util';
import { useAppContext } from '../../../../Services/AppContext';
import Text from '../../../../Components/Base/Text/Text';
import { getSickLeaveSubmissionSubTypeTx } from '../../Helpers/sickLeaveSubmissionSubType.helper';

interface Props {
	submission: Document;
}

const CSSZSickLeaveCertificateDetailSubmissionItem = ({
	submission,
}: Props) => {
	const { dateFormatMoment } = useAppContext();
	const subTypeTx = getSickLeaveSubmissionSubTypeTx(submission.subType);

	return (
		<div className={styles.wrapper}>
			<time dateTime={submission.createdAt}>
				{getMomentDate(submission.createdAt).format(
					`${dateFormatMoment} HH:mm`,
				)}
			</time>
			{subTypeTx != null ? (
				<Text tx={subTypeTx} inline />
			) : (
				<span>{submission.subType}</span>
			)}
		</div>
	);
};

export default CSSZSickLeaveCertificateDetailSubmissionItem;
